/* globals IntegrationImplementation, Control */
/* eslint-disable new-cap, camelcase */
function MenuItem (parentMenuItem, activity, documentObject) {
    var nodeTag,
        node;

    this.ParentMenuItem = parentMenuItem;

    //
    // No longer storing the activity data on the menu object since sometimes we'll be rendering
    // lookahead data and sometimes "real-time" sequencing data. Appropriate methods now take the
    // activity as a parameter. The activity passed into the constructor is used to get the
    // ActivityId, which will never change and is also used to initialize the display.
    //
    // this.Activity = activity;
    //
    this.Document = documentObject;

    //
    // Changing from just the Item Identifier to a combination of item identifier and database
    // identifier. When it was just item identifier, the getElementById function would not
    // distinguish between elements that differed only by case. Keeping the item identifier
    // to make the ids less cryptic and easier to work with.
    //
    this.ActivityId = activity.GetItemIdentifier() + activity.GetDatabaseIdentifier();
    this.MenuElementId = "MenuItem" + this.ActivityId;

    this.el = null;

    if (parentMenuItem === null) {
        this.Level = 0;
    }
    else {
        this.Level = parentMenuItem.Level + 1;
    }

    this.Children = [];
    this.Visible = true;

    // Enabled means "show as a link", Disabled will still show the menu item
    // but as simple text rather than a link
    this.Enabled = true;

    // create the actual element on the DOM
    nodeTag = "div";
    if (typeof IntegrationImplementation.GetMenuItemElementTag === "function") {
        nodeTag = IntegrationImplementation.GetMenuItemElementTag();
    }

    node = this.Document.createElement(nodeTag);
    node.id = this.MenuElementId;

    this.el = node;

    this.CurrentDisplayState = null;

    this.CurrentDisplayState = IntegrationImplementation.PopulateMenuItemElement(
        node,
        this.Document,
        this.ActivityId,
        activity.GetTitle(),
        this.Level,
        activity.IsDeliverable(),
        Control.Package.LearningStandard,
        Control.Package.Properties.StatusDisplay,
        activity.GetItemIdentifier(),
        activity,
        this
    );
}

/* eslint-disable no-use-before-define */
MenuItem.prototype.Render = MenuItem_Render;
MenuItem.prototype.UpdateStateDisplay = MenuItem_UpdateStateDisplay;
MenuItem.prototype.Hide = MenuItem_Hide;
MenuItem.prototype.Show = MenuItem_Show;
MenuItem.prototype.Enable = MenuItem_Enable;
MenuItem.prototype.Disable = MenuItem_Disable;
MenuItem.prototype.BumpUpLevel = MenuItem_BumpUpLevel;
MenuItem.prototype.BumpDownLevel = MenuItem_BumpDownLevel;
MenuItem.prototype.ResynchChildren = MenuItem_ResynchChildren;
/* eslint-enable no-use-before-define */

// private
function MenuItem_getLastSubmenuItem (menuItem) {
    // if there are no children, then this is the last item so return it
    if (menuItem.Children.length === 0) {
        return menuItem;
    }

    // otherwise, find the last (grand)child of the last child in this menu item
    return MenuItem_getLastSubmenuItem(menuItem.Children[menuItem.Children.length - 1]);
}

function MenuItem_Render (activity) {
    // Figure out the previous node
    var nodeToInsertAfter,
        i,
        prevMenuItem,
        lastChildOfPrevMenuItem;

    // if this is the root node, insert it at the appropriate spot on the page
    if (this.ParentMenuItem === null) {
        nodeToInsertAfter = IntegrationImplementation.GetHtmlElementToInsertMenuWithin();
        nodeToInsertAfter.insertBefore(this.el, null);

        return;
    }

    //
    // otherwise, we need to find the last (grand)child of the previous sibling and insert after it
    //

    // find the location of this activity within the parent
    for (i = 0; i < this.ParentMenuItem.Children.length; i += 1) {
        if (this.ParentMenuItem.Children[i].ActivityId === this.ActivityId) {
            break;
        }
    }

    // if this is the first activity in the parent, insert right after the parent
    if (i === 0) {
        nodeToInsertAfter = this.Document.getElementById(this.ParentMenuItem.MenuElementId);
    }
    else {
        // otherwise, find the immediately previous sibling's last (grand)child
        prevMenuItem = this.ParentMenuItem.Children[i - 1];
        lastChildOfPrevMenuItem = MenuItem_getLastSubmenuItem(prevMenuItem);
        nodeToInsertAfter = this.Document.getElementById(lastChildOfPrevMenuItem.MenuElementId);
    }

    // there is no "insertAfter" method that is cross browser compatible, so we want to insert
    // between the "after" node and whatever comes next (its nextSibling)
    nodeToInsertAfter.parentNode.insertBefore(this.el, nodeToInsertAfter.nextSibling);

    if (activity.DisplayInChoice() === true) {
        this.Show();
    }
    else {
        this.Hide();
    }
}

function MenuItem_UpdateStateDisplay (activity, currentActivity, navigationRequestInfo, useLookAheadActivityStatus) {
    /* globals
        INVALID_MENU_ITEM_ACTION_DISABLE,
        INVALID_MENU_ITEM_ACTION_HIDE,
        INVALID_MENU_ITEM_ACTION_SHOW_ENABLE
    */
    var newVisible = true,
        newEnabled = true;

    if (activity.DisplayInChoice() === true) {
        newVisible = true;
    }
    else {
        newVisible = false;
    }

    // If the nav request won't succeed, hide it if this package is configured to do so
    if (! navigationRequestInfo.WillSucceed) {
        if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_DISABLE) {
            newEnabled = false;
        }
        else if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_HIDE) {
            newVisible = false;
        }
        else if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_SHOW_ENABLE) {
            newVisible = true;
        }
    }
    else {
        // eslint-disable-next-line no-lonely-if
        if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_DISABLE) {
            newEnabled = true;
        }
        else if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_HIDE) {
            newVisible = true;
        }
        else if (Control.Package.Properties.InvalidMenuItemAction === INVALID_MENU_ITEM_ACTION_SHOW_ENABLE) {
            newVisible = true;
        }
    }

    if (newVisible !== this.Visible) {
        if (newVisible === true) {
            this.Show();
        }
        else {
            this.Hide();
        }
    }

    if (activity.IsTheRoot() === true && Control.Package.Properties.ForceDisableRootChoice === true) {
        newEnabled = false;
    }

    if (newEnabled !== this.Enabled) {
        if (newEnabled === true) {
            this.Enable(activity.GetItemIdentifier(), activity.GetTitle());
        }
        else {
            this.Disable();
        }
    }

    this.CurrentDisplayState = IntegrationImplementation.UpdateMenuStateDisplay(
        this.el,
        this.Document,
        activity,
        this.ActivityId,
        activity.IsDeliverable(),
        currentActivity,
        navigationRequestInfo,
        Control.Package.LearningStandard,
        Control.Package.Properties.StatusDisplay,
        this.CurrentDisplayState,
        useLookAheadActivityStatus
    );
}

function MenuItem_Hide () {
    // only affect the element if there will be a state change
    if (this.Visible === true) {
        this.el.style.display = "none";
        this.BumpDownLevel(this);
    }

    this.Visible = false;
}

function MenuItem_Show () {
    // only affect the element if there will be a state change
    if (this.Visible === false) {
        this.el.style.display = "inline";
        this.BumpUpLevel(this);
    }

    this.Visible = true;
}

function MenuItem_Enable (activityIdentifier) {
    /* globals GetController */
    // only affect the element if there will be a state change
    if (this.Enabled === false) {
        this.el.tabIndex = 0;
        this.el.onclick = function () {
            GetController().ChoiceRequest(activityIdentifier);

            return true;
        };
        this.el.onkeydown = function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                GetController().ChoiceRequest(activityIdentifier);

                return true;
            }
        };
    }

    this.Enabled = true;
}

function MenuItem_Disable () {
    // only affect the element if there will be a state change
    if (this.Enabled === true) {
        this.el.tabIndex = -1;
        this.el.onclick = "";
        this.el.onkeydown = "";
    }

    this.Enabled = false;
}

function MenuItem_BumpUpLevel (menuItemToBump) {
    var childIndex;

    menuItemToBump.Level += 1;
    IntegrationImplementation.UpdateIndentLevel(menuItemToBump.el, menuItemToBump.ActivityId, menuItemToBump.Level);

    for (childIndex in menuItemToBump.Children) {
        if (menuItemToBump.Children.hasOwnProperty(childIndex)) {
            menuItemToBump.BumpUpLevel(menuItemToBump.Children[childIndex]);
        }
    }
}

function MenuItem_BumpDownLevel (menuItemToBump) {
    var childIndex;

    menuItemToBump.Level -= 1;
    IntegrationImplementation.UpdateIndentLevel(menuItemToBump.el, menuItemToBump.ActivityId, menuItemToBump.Level);

    for (childIndex in menuItemToBump.Children) {
        if (menuItemToBump.Children.hasOwnProperty(childIndex)) {
            menuItemToBump.BumpDownLevel(menuItemToBump.Children[childIndex]);
        }
    }
}

function MenuItem_ResynchChildren (activity) {
    // remove all the children from the DOM
    var childElement,
        childIndex,
        availableChildren,
        childActivity;

    for (childIndex in this.Children) {
        if (this.Children.hasOwnProperty(childIndex)) {
            childElement = this.Children[childIndex].el;
            childElement.parentNode.removeChild(childElement);
        }
    }

    // reset the children to the new children
    this.Children = [];

    availableChildren = activity.GetAvailableChildren();

    for (childActivity in availableChildren) {
        if (availableChildren.hasOwnProperty(childActivity)) {
            this.Children[childActivity] = availableChildren[childActivity].MenuItem;
        }
    }
}
